import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    Grid,
    Autocomplete,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TablePagination,
    IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useSucursal } from '../contexts/SucursalContext';
import { useAccesos } from '../contexts/AccesosContext';
import useCajaAbiertaValidation from '../hooks/useCajaAbiertaValidation';

const MovimientosExtraordinarios = () => {    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { user } = useUser();    const { cajaAbiertaDatos, verificarAperturaCaja, validarOperacionCritica } = useSucursal();
    const { validarCajaAbierta, cajaAbierta } = useCajaAbiertaValidation();

    const [tiposTransaccion, setTiposTransaccion] = useState([]);
    const [tipoTransaccionSeleccionado, setTipoTransaccionSeleccionado] = useState('');
    const [efectivoActual, setEfectivoActual] = useState(0);
    const [valor, setValor] = useState('');
    const [concepto, setConcepto] = useState('');
    const [movimientos, setMovimientos] = useState([]);

    // Cargar los tipos de transacción al montar el componente
    useEffect(() => {
        fetchTiposTransaccion();
        fetchEfectivoActual();
        fetchMovimientos();

        console.log(cajaAbiertaDatos);

    }, []);

    const fetchTiposTransaccion = async () => {
        try {
            const response = await fetch(`${server}/MgCajaTipoTransaccions`);
            const data = await response.json();
            // Mostrar todos los tipos de transacción disponibles
            const todosLosTipos = data.$values || data || [];
            setTiposTransaccion(todosLosTipos);
        } catch (error) {
            console.error('Error al cargar tipos de transacción:', error);
        }
    };

    const fetchEfectivoActual = async () => {
        try {
            const response = await fetch(`${server}/MgCaja/EfectivoActual`);
            const data = await response.json();
            setEfectivoActual(data.valor || 0);
        } catch (error) {
            console.error('Error al cargar efectivo actual:', error);
        }
    };

    const fetchMovimientos = async () => {
        try {
            // Asegurarse de que cajaAbiertaDatos tenga un valor válido
            if (!cajaAbiertaDatos || !cajaAbiertaDatos) {
                console.warn('Caja abierta no definida.');
                return;
            }
            const response = await fetch(`${server}/MgCajaArqueoDetalleSistemas/porIdEncabezado/${cajaAbiertaDatos}`);
            const data = await response.json();
            const allMovimientos = data.$values || data || [];
            // Mostrar todos los movimientos
            console.log(allMovimientos);
            setMovimientos(allMovimientos);
        } catch (error) {
            console.error('Error al cargar movimientos:', error);
        }
    };    const handleGuardar = async () => {
        // Validar que la caja esté abierta y tenga conteo antes de continuar
        const operacionValida = await validarOperacionCritica('movimientos extraordinarios');
        if (!operacionValida) {
            return;
        }

        if (!tipoTransaccionSeleccionado || !valor || !concepto) {
            Swal.fire('Error', 'Por favor complete todos los campos obligatorios.', 'error');
            return;
        }

        const payload = {
            idTipoTransaccion: tipoTransaccionSeleccionado,
            valor: parseFloat(valor),
            concepto,
            ingresadoPor: user?.codigoUsuario || 'ADMIN',
            idEncabezado: cajaAbiertaDatos,
            ingresoExtraOrdinario: true
        };

        try {
            const response = await fetch(`${server}/MgCajaArqueoDetalleSistemas`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                Swal.fire('Éxito', 'Movimiento guardado correctamente.', 'success');
                fetchMovimientos(); // Recargar la tabla
                setTipoTransaccionSeleccionado('');
                setValor('');
                setConcepto('');
            } else {
                const errorData = await response.json();
                Swal.fire('Error', errorData.message || 'Ocurrió un error al guardar el movimiento.', 'error');
            }
        } catch (error) {
            console.error('Error al guardar el movimiento:', error);
            Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
        }
    };

    return (
        <div className="right_col" role="main">
            <div className="x_content">
                {/* <div className="row"> */}
                {/* <div className="col-md-8 col-sm-7 offset-md-2"> */}
                <h1>Movimientos Extraordinarios</h1>
                <Grid container spacing={2}>
                    {/* Select de tipo de transacción */}
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Tipo de Transacción</InputLabel>
                            <Select
                                value={tipoTransaccionSeleccionado}
                                onChange={(e) => setTipoTransaccionSeleccionado(e.target.value)}
                                label="Tipo de Transacción"
                            >
                                {tiposTransaccion.map((tipo) => (
                                    <MenuItem key={tipo.id} value={tipo.id}>
                                        {tipo.descripcionTipoTransaccion}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {/* Campo para mostrar efectivo actual */}
                    <Grid item xs={12} sm={2}>
                        <TextField
                            label="Efectivo Actual"
                            value={efectivoActual}
                            fullWidth
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    {/* Campo de valor */}
                    <Grid item xs={12} sm={2}>
                        <TextField
                            label="Valor"
                            type="number"
                            value={valor}
                            onChange={(e) => setValor(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    {/* Campo de concepto */}
                    <Grid item xs={12} sm={7}>
                        <TextField
                            label="Concepto"
                            value={concepto}
                            onChange={(e) => setConcepto(e.target.value)}
                            fullWidth
                        />
                    </Grid>
                    {/* Botón para guardar */}
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" onClick={handleGuardar} disabled={!tienePermiso('Crear Movimiento Extraordinario')}>
                            Guardar
                        </Button>
                    </Grid>
                </Grid>

                {/* Tabla para mostrar movimientos */}
                <h2>Listado de Movimientos</h2>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Tipo de Transacción</TableCell>
                                <TableCell>Valor</TableCell>
                                <TableCell>Concepto</TableCell>
                                <TableCell>Ingresado Por</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {movimientos.map((movimiento) => (
                                <TableRow key={movimiento.id}>
                                    <TableCell>{movimiento.descripcionTipoTransaccion}</TableCell>
                                    <TableCell>{movimiento.valor}</TableCell>
                                    <TableCell>{movimiento.concepto}</TableCell>
                                    <TableCell>{movimiento.ingresadoPor}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* </div> */}
                {/* </div> */}
            </div>
        </div>
    );
};

export default MovimientosExtraordinarios;
